import { memo } from 'react';
import Layout from '@/shared/Layout/ui/Layout';
import Head from 'next/head';
import Confirmation from '@/screens/CheckoutPage/ui/Confirmation/Confirmation';
import { useGetOrder } from '../app/useGetOrder';
import { Preloader } from '@/common/ui/loaders/Preloader';
import { Wrapper } from './OrdersPage.styles';
import { Container } from '@/common/ui/containers/Container';
import { useRouter } from 'next/router';
import { AccessForm } from './AccessForm';
import { useCheckoutContext } from '@/common/app/contexts';
import { shopperApproved } from '@/scripts/shopperApproved';

const OrderAccessContainer = () => {
    const {
        query: { key },
        isReady,
    } = useRouter();
    const { order: stateOrder, isLoading: stateLoading, isThankYou } = useCheckoutContext();
    const { order: requestedOrder, loading: requestedLoading } = useGetOrder({
        skipReuest: stateOrder.detail.accesskey === key || stateLoading,
    });

    const order = stateOrder.detail.accesskey === key ? stateOrder.detail : requestedOrder;
    const loading = stateLoading || requestedLoading;
    const productIds =
        isThankYou &&
        !!order &&
        Object.values(order.cart_items)
            .map((item) => item.trip_id)
            .join();

    if (isReady && !key) {
        return <AccessForm />;
    }

    return (
        <Layout>
            <Head>
                <title>Access - TripShock!</title>
                <meta name="description" key="description" content="" />
                {isThankYou && !!order && (
                    <>
                        <script
                            id="ShopperApproved"
                            type="text/javascript"
                            dangerouslySetInnerHTML={{
                                __html: shopperApproved(
                                    order.id,
                                    order.customer_first_name,
                                    order.customer_last_name,
                                    order.customer_email
                                ),
                            }}
                        />
                        <script
                            async
                            src="https://tripshock.services.answerbase.com/javascript/widget/conversion-tracking.min.js"
                            data-sale_total={order.gross_total}
                            data-email={order.customer_email}
                            data-productId={productIds}
                            data-sku={productIds}
                            data-price={Object.values(order.cart_items)
                                .map((item) => item.grand_total)
                                .join()}
                        />
                    </>
                )}
            </Head>
            <Wrapper>
                <Container>
                    {loading && <Preloader minHeight="calc(100vh - 50px)" />}
                    {order && !loading && (
                        <Confirmation
                            isCheckout={isThankYou}
                            assessOrder={order}
                            grandTotal={stateOrder.detail.gross_total || order.gross_total}
                        />
                    )}
                </Container>
            </Wrapper>
        </Layout>
    );
};

export const OrderAccess = memo(OrderAccessContainer);
